import { useState } from 'react';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import { useUserContext } from '../../../hooks/userHook';
import { deleteSchedule, deleteSchedules } from '../../../data/api';
import toast from '../../Toast';

export const DELETE_TYPES = {
  'Single': 'SINGLE',
  'Recurrence': 'RECURRENCE'
};

type DeleteProps = {
  scheduleId: string;
  deleteType: string;
  successCallback?: Function;
  [x: string]: any;
};

export default function Delete({ scheduleId, deleteType, successCallback, ...rest }: DeleteProps) {
  const { user } = useUserContext();
  const [loading, setLoading] = useState<boolean>(false);

  const submitHandler = async (event: any) => {
    event.preventDefault();
    let result = null;
    setLoading(true);

    if (deleteType === DELETE_TYPES.Single) {
      result = await deleteSchedule(scheduleId, user?.token);
    }

    if (deleteType === DELETE_TYPES.Recurrence) {
      result = await deleteSchedules(scheduleId, user?.token);
    }

    if (result?.success) {
      successCallback && successCallback();
      toast.success(result.message);
    } else {
      toast.error(result?.message);
    }

    setLoading(false);
  };

  const disabled = loading || scheduleId === '';

  return (
    <div className="d-flex flex-column">
      <Button
        size="sm"
        variant="danger"
        {...rest}
        type="button"
        className={`d-flex justify-content-center align-items-center ${rest.className || ''}`}
        onClick={submitHandler}
        disabled={disabled}
      >
        <span>{deleteType === DELETE_TYPES.Single ? 'Delete' : 'Delete All'}</span>
        {loading && <Spinner animation="border" variant="light" size="sm" className="ms-2" />}
      </Button>
    </div>
  );
}